import { useQuery } from "@tanstack/react-query";
import Seo from "@/components/Seo";
import { getPageSeo } from "@/lib/api";

/**
 * Page-level SEO: admin-managed values from the page-seo collection override
 * the hardcoded fallbacks passed as props.
 */
export default function PageSeo({ slug, title, description, keywords, image, schemas = [] }) {
  const { data: seo = {} } = useQuery({
    queryKey: ["page-seo", slug],
    queryFn: () => getPageSeo(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
  return (
    <Seo
      title={seo.metaTitle || title}
      description={seo.metaDescription || description}
      keywords={seo.keywords || keywords}
      image={seo.ogImage || image}
      schemas={schemas}
    />
  );
}
